import React from 'react';
import styled from 'styled-components';
import { useI18n } from '@oneaudi/i18n-context';
import { Notification } from '@oneaudi/unified-web-components';
import { messages } from '../../../i18n/messages';
import mapContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import trackingContext from '../../../contexts/tracking-context';
import { trackUserLocationAction } from '../../../utils/trackingUtils';
import { TrackingEvents } from '../../../utils/trackingService';

export default function LocationErrorMessage() {
  const dispatch = mapContext.useMapDispatch();
  const { trackingService: tService } = trackingContext.useTrackingState();
  const { isUserLocationPermissionGiven } = mapContext.useMapState();

  React.useEffect(() => {
    if (isUserLocationPermissionGiven) {
      trackUserLocationAction(tService, TrackingEvents.LOCATION_NOT_RETRIEVED_PERMISSION_GIVEN);
    }
  }, []);

  return (
    <LocationErrorMessageContainer
      closeButton={{
        ariaLabel: 'Close notification',
        onClick: () => dispatch({ type: ActionTypes.setShowLocationError, payload: false }),
      }}
      copy={useI18n(messages.error_message_body)}
      icon="caution"
      margin={[0, 0, 0, 0]}
      title={{
        tag: 'span',
        text: useI18n(messages.error_message_header),
      }}
      data-testid="location-error-container"
    />
  );
}

const LocationErrorMessageContainer = styled(Notification)`
  max-width: 400px;
  margin-right: 10px;
  margin-top: 10px;
  position: absolute;
  right: 0;
  justify-content: space-between;
  flex-direction: row;
  display: flex;
  z-index: 1;
`;
